import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store/index';
import { setStudioSearchSortByAction } from '../slice';

const setStudioSearchSortByOperation =
  (sortBy: string) => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>) => {
    await dispatch(setStudioSearchSortByAction(sortBy));
  };

export default setStudioSearchSortByOperation;
